/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IAccountingTransaction } from 'app/shared/model/accounting-transaction.model';
import { IAccountingBankAccount } from 'app/shared/model/accounting-bank-account.model';

export interface IAccountingTax {
  id?: string;
  name?: string | null;
  rate?: string | null;
  country?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  type?: IClinicalDictionary | null;
  transactions?: IAccountingTransaction[] | null;
  accounts?: IAccountingBankAccount[] | null;
}

export const defaultValue: Readonly<IAccountingTax> = {
  active: false,
};
